<script>
import { type, deepCopy } from '../../utils/assist'
import Configurable from '../a-map/configurable'
import EventAgent from '../a-map/eventAgent'

// 覆盖物-多边形
export default {
    name: "AMapPolygon",

    mixins: [Configurable, EventAgent],

    inject: {
        amap: { default: null }
    },

    data() {
        return {
            polygon: null
        }
    },

    props: {
        // 标记的叠加顺序
        zIndex: {
            type: Number,
            default: 100
        },
        // 多边形轮廓线的节点坐标数组
        path: {
            type: Array,
        },
        // 是否将覆盖物的鼠标或touch等事件冒泡到地图上 
        bubble: {
            type: Boolean,
            default: false
        },
        // 指定鼠标悬停时的鼠标样式，自定义cursor
        cursor: {
            type: String,
        },
        // 线条颜色，使用16进制颜色代码赋值
        strokeColor: {
            type: String,
            default: "#006600"
        },
        // 轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明
        strokeOpacity: {
            type: Number,
            default: 0.9
        },
        // 轮廓线宽度
        strokeWeight: {
            type: Number,
        },
        // 多边形填充颜色，使用16进制颜色代码赋值
        fillColor: {
            type: String,
            default: "#FFAA00"
        },
        // 多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明
        fillOpacity: {
            type: Number,
            default: 0.9
        },
        // 设置点标记是否可拖拽移动
        draggable: {
            type: Boolean,
            default: false
        },
        // 用户自定义属性
        extData: {
            type: Object,
            dfeault: () => ({})
        },
        // 轮廓线样式
        strokeStyle: {
            type: String,
            validator(val) {
                return ["solid", "dashed"].indexOf(val) >= 0
            }
        },
        // 勾勒形状轮廓的虚线和间隙的样式，此属性在strokeStyle 为dashed 时有效
        strokeDasharray: {
            type: Array
        },
    },

    methods: {
        initPolygon() {
            if (AMap && AMap.Polygon) {
                this.polygon = new AMap.Polygon(this.config)

                // 事件监听
                this.startAgent(this.polygon)

                return this.polygon
            } else {
                return new Error("AMap.Polygon插件未加载")
            }
        },
        resolve() {
            return "polygon"
        },
    },

    render(h) {},

    watch: {
        // 重新配置
        'config': {
            handler(val) {
                if (this.polygon) {
                    this.polygon.setOptions(val)
                }
            },
            deep: true
        }
    },

    created() {
        this.$watch(function() {
            return this.amap.load
        }, function(load) {
            // map 创建完毕
            if (load) {
                // AMap的直接子级
                if (this.$parent.$options.name == "AMap") {
                    this.configBubble = false

                    var polygon = this.initPolygon()

                    if (type(polygon) == "error") {
                        throw polygon
                    }

                    this.amap.map.add(polygon)
                    this.amap.overlay.push(polygon)
                }
            }
        }, {
            immediate: true
        })
    },

    beforeDestroy() {
        if (this.polygon) {
            // 从amap移除
            this.amap.map.remove(this.polygon)
            this.amap.overlay.splice(this.amap.overlay.indexOf(this.polygon), 1)
            // 事件解绑
            this.stopAgent(this.polygon)
        }
    }
}
</script>